import { render } from "./AddPostModal.vue?vue&type=template&id=4c43012a&ts=true"
import script from "./AddPostModal.vue?vue&type=script&lang=ts"
export * from "./AddPostModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__